import Edit from './Edit';
import List from './List';

export default { Edit, List };



// WEBPACK FOOTER //
// ./src/pages/Installers/index.js